// What goes in the send box (owner, 2026-10-07): « The send box still holds a
// message that was already sent. Clear it once the message goes out, so nobody
// sends it twice. » +212 613 66 05 37: the agent's 22:12 answer went out and
// sat in the box, ready to go a second time.
//
// The assistant's draft is offered only while nothing has sent it: not once it
// is sent or on its way, and not when the same words are already the last
// thing we said in the chat. Pure — guard: suggestion.test.ts
const norm = (s: string | null | undefined) => String(s ?? '').replace(/\s+/g, ' ').trim();

export function sendBoxSuggestion(
  draft: { reply?: string | null; send_state?: string | null; updated_at?: string | null } | null | undefined,
  messages: Array<{ direction?: string | null; body?: string | null; created_at?: string | null }>,
): string {
  const reply = norm(draft?.reply);
  if (!reply) return '';
  // ⚠️ OLDER THAN HER LAST MESSAGE → NOT OFFERED (2026-10-07). Ghita #1216: a
  // failed 29 Sept « Wslatna la couverture » sat in the box and went out on
  // 6 Oct, after she wrote « je n'aime pas la couverture ».
  const madeAt = Date.parse(String(draft?.updated_at ?? ''));
  const herLast = [...messages].reverse().find((m) => m.direction === 'in');
  if (Number.isFinite(madeAt) && herLast && Date.parse(String(herLast.created_at ?? '')) > madeAt) return '';
  if (['sent', 'pending', 'sending'].includes(String(draft?.send_state ?? ''))) return '';
  const lastOut = [...messages].reverse().find((m) => m.direction === 'out');
  if (lastOut && norm(lastOut.body) === reply) return '';
  return String(draft?.reply ?? '');
}
